import { render, staticRenderFns } from "./outdata.vue?vue&type=template&id=2d354b86&scoped=true"
import script from "./outdata.vue?vue&type=script&lang=js"
export * from "./outdata.vue?vue&type=script&lang=js"
import style0 from "./outdata.vue?vue&type=style&index=0&id=2d354b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d354b86",
  null
  
)

export default component.exports